/** Stage 38 · Scale, Performance & Resilience — evidence-only. */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Gauge } from "lucide-react";

export default function Scale() {
  const [d, setD] = useState(null);
  useEffect(()=>{ api.get("/scale/overview").then(({data})=>setD(data)).catch(()=>setD(null)); }, []);
  if (!d) return <div className="text-sm text-slate-500 p-6">Loading…</div>;
  return (
    <div className="max-w-6xl space-y-5" data-testid="scale-page">
      <div>
        <div className="text-[10px] font-semibold tracking-[0.14em] uppercase text-slate-500">Operations · Scale</div>
        <h1 className="text-3xl font-heading font-semibold text-slate-900 tracking-tight mt-1 inline-flex items-center gap-2"><Gauge className="h-7 w-7" /> Scale & Resilience</h1>
        <p className="text-sm text-slate-600 mt-2 max-w-2xl">Evidence-only load results. Never invents throughput. External runners (k6, Locust) POST results here.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Tile label="Passed (30d)" value={d.tiles?.passed_30d} color="text-emerald-700" testid="scale-passed" />
        <Tile label="Failed (30d)" value={d.tiles?.failed_30d} color="text-rose-700" />
        <Tile label="Total runs"   value={d.tiles?.total_results} />
        <Tile label="Master cos"   value={d.live_counts?.master_companies} />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {Object.entries(d.live_counts||{}).map(([k,v])=><Tile key={k} label={k.replace(/_/g," ")} value={v} />)}
      </div>
      <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
        <div className="p-3 border-b border-slate-200 text-sm font-medium">Latest recorded results ({(d.latest_results||[]).length})</div>
        {(d.latest_results||[]).length===0 ? <div className="p-6 text-sm text-slate-500">No load results recorded. Run k6/Locust and POST /api/scale/results.</div>
          : <table className="w-full text-sm">
              <thead className="text-[10px] uppercase tracking-widest text-slate-500 bg-slate-50"><tr><th className="text-left py-2 px-3">Scenario</th><th className="text-left py-2 px-3">Profile</th><th className="text-right py-2 px-3">Users</th><th className="text-right py-2 px-3">p95 ms</th><th className="text-right py-2 px-3">RPS</th><th className="text-left py-2 px-3">Result</th></tr></thead>
              <tbody>
                {d.latest_results.map(r=>(
                  <tr key={r.id} className="border-t border-slate-100">
                    <td className="py-2 px-3 font-mono text-xs text-slate-900">{r.scenario}</td>
                    <td className="py-2 px-3 text-xs text-slate-600">{r.profile}</td>
                    <td className="py-2 px-3 text-right tabular-nums">{r.concurrent_users}</td>
                    <td className="py-2 px-3 text-right tabular-nums">{r.p95_ms ?? "—"}</td>
                    <td className="py-2 px-3 text-right tabular-nums">{r.throughput_rps ?? "—"}</td>
                    <td className="py-2 px-3"><span className={"text-[10px] font-semibold uppercase tracking-widest px-1.5 py-0.5 rounded border " + (r.passed ? "bg-emerald-100 text-emerald-800 border-emerald-200" : "bg-rose-100 text-rose-800 border-rose-200")}>{r.passed ? "pass" : "fail"}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>}
      </div>
      <details className="text-xs bg-slate-50 border border-slate-200 rounded-md p-3">
        <summary className="cursor-pointer font-medium text-slate-700">Test profiles</summary>
        <pre className="mt-2 bg-white p-2 rounded border border-slate-100 overflow-auto max-h-64">{JSON.stringify(d.profiles, null, 2)}</pre>
      </details>
    </div>
  );
}
function Tile({label, value, color, testid}) {
  return <div className="rounded-md border border-slate-200 bg-white p-3" data-testid={testid}><div className="text-[10px] uppercase tracking-widest text-slate-500">{label}</div><div className={"mt-1 text-2xl font-heading font-semibold tabular-nums " + (color||"text-slate-900")}>{value ?? "—"}</div></div>;
}
